import { BodyPix } from "@tensorflow-models/body-pix";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import store from '../../store/redux-store/root_store';
import { initialStateModel, ParticipantDetails } from "../../base/models/meetModal";
import { BackgroundConfig } from "../virtualBackground/core/helpers/backgroundHelper";
import { SegmentationConfig } from "../virtualBackground/core/helpers/segmentationHelper";
import { TFLite } from "../virtualBackground/core/hooks/useTFLite";
import { SourcePlayback } from "../virtualBackground/core/helpers/sourceHelper";
import { PostProcessingConfig } from "../virtualBackground/core/helpers/postProcessingHelper";
import useRenderingPipeline from "../virtualBackground/core/hooks/useRenderingPipeline";


type VideoRenderProps = {
    backgroundConfig: BackgroundConfig;
    segmentationConfig: SegmentationConfig;
    bodyPix: BodyPix;
    tflite: TFLite;
    sourcePlayBack: SourcePlayback;
    postProcessingConfig: PostProcessingConfig;
    participant: ParticipantDetails;
    innerStyles: any;
    imgIndex: number;
}
declare global {
  interface HTMLCanvasElement {
    captureStream(frameRate?: number): MediaStream;
 }
}
export const VirtualBGRender =({ backgroundConfig, segmentationConfig, bodyPix, tflite, sourcePlayBack,
  postProcessingConfig,participant, innerStyles }: VideoRenderProps) => {
  const virtualBGState:{image:any,imgIndex: number,viewMode:string,peerConCheck:boolean} =
  useSelector((state:initialStateModel) => state.VirtualBG);
  const {currdeviceinfo} = useSelector((state:initialStateModel) => state.meetingReducer);
  const {
    pipeline,
    backgroundImageRef,
    canvasRef,
    renderID
  } = useRenderingPipeline(
    sourcePlayBack,
    backgroundConfig,
    segmentationConfig,
    bodyPix,
    tflite
  );
  useEffect(() => {
    let videoRenderList: any = store.getState().storeVideo.participantList || [];
    let index: number = -1;
    index = videoRenderList.findIndex((elem:any) => elem.participants === currdeviceinfo.conId);
    if (pipeline && virtualBGState.imgIndex) {
      console.log(participant.isMirror,"virtualBGState.imgIndex---->",virtualBGState.imgIndex);
      if(renderID){
      
        // cancelAnimationFrame(renderID);
        // pipeline?.cleanUp();
      }

      pipeline.updatePostProcessingConfig(postProcessingConfig);
      if(index !== -1) {
        var canvasElt = document.querySelector('canvas');
        if (canvasElt) {
          const streamCanvas = canvasElt.captureStream(25); // 25 FPS
          let pc: any = videoRenderList[index].userAgent.sessionDescriptionHandler.peerConnection;
          console.log("virtualBGState.peerConCheck",virtualBGState.peerConCheck);
          if(virtualBGState.peerConCheck){
          pc.getSenders().forEach(async (sender: any) => {
            if (sender.track) {
            if (sender.track.kind === "video") {
              sender?.replaceTrack(streamCanvas.getVideoTracks()[0]);
            }
          }
          });
        }
          // let stream: any = videoRenderList[index].stream;
          // var videoTrack = stream.getVideoTracks();
          // if (videoTrack.length > 0) {
          //   stream.getTracks().forEach((track: any) => (track.kind === "video" ? track.stop() : ''));
          //   stream.removeTrack(videoTrack[0]);
          //   stream.addTrack(streamCanvas.getVideoTracks()[0]);
          // }
        }
      }
    }
    if(!virtualBGState.image){
      let pc: any = videoRenderList[index].userAgent.sessionDescriptionHandler.peerConnection;
      pc.getSenders().forEach(async(sender: any) => {
        if (index !== -1) {
          if (renderID && sender.track) {
            if (sender.track.kind === "video") {
              let stream: any = videoRenderList[index].stream;
              sender?.replaceTrack(stream.getVideoTracks()[0]);
            }
            clearTimeout(renderID);
          }
          // pipeline?.cleanUp();
        }
      });
    }
  }, [pipeline, postProcessingConfig,virtualBGState.imgIndex, virtualBGState.viewMode,virtualBGState.peerConCheck]);
  //console.log(currdeviceinfo.isMirror,"Virtual BG---->", innerStyles);
  return (<>
    {backgroundConfig.type === 'image' && virtualBGState.image && (
      <img
        ref={backgroundImageRef}
        src={virtualBGState.image}
        alt=""
        hidden={segmentationConfig.pipeline === 'webgl2'}
      />
    )}
    <canvas
      // The key attribute is required to create a new canvas when switching
      // context mode
      
      // eslint-disable-next-line max-len
      style={virtualBGState.image?innerStyles:{"position":"unset"}}
      key={currdeviceinfo.deviceid}
      ref={canvasRef}
      width={sourcePlayBack.width}
      height={sourcePlayBack.height}
    />
  </>);
};